import { render, staticRenderFns } from "./QuestionPhoneVerification.vue?vue&type=template&id=e77b577e&"
import script from "./QuestionPhoneVerification.vue?vue&type=script&lang=js&"
export * from "./QuestionPhoneVerification.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPhoneVerification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports